import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/paper/success.png'
import _imports_1 from '@/assets/paper/error.png'


const _withScopeId = n => (_pushScopeId("data-v-b1372c92"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "dv-question-title" }
const _hoisted_2 = { style: {"display":"flex"} }
const _hoisted_3 = {
  key: 0,
  class: "dv-title-index"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  id: "dvCompile",
  class: "dv-title"
}, null, -1))
const _hoisted_5 = {
  key: 1,
  class: "dv-title-score"
}
const _hoisted_6 = { class: "dv-options" }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = { class: "dv-options-num" }
const _hoisted_9 = ["innerHTML"]
const _hoisted_10 = {
  key: 0,
  class: "dv-answer"
}
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))
const _hoisted_12 = [
  _hoisted_11
]
const _hoisted_13 = {
  key: 1,
  class: "dv-answer"
}
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_1 }, null, -1))
const _hoisted_15 = [
  _hoisted_14
]
const _hoisted_16 = {
  key: 0,
  class: "question-analysis"
}
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "analysis-title" }, "解析:", -1))
const _hoisted_18 = ["innerHTML"]
const _hoisted_19 = { class: "dynamic-content-preview-card" }
const _hoisted_20 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ElDialog = _resolveComponent("ElDialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.showQuestionNum)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_ctx.questionData.indexInQuestion !== undefined
            ? _ctx.questionData.indexInQuestion + "."
            : "") + _toDisplayString(_ctx.questionData.titleNum > 0 ? _ctx.questionData.titleNum : ""), 1))
        : _createCommentVNode("", true),
      _hoisted_4,
      (_ctx.showQuestionScore)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, " (" + _toDisplayString(_ctx.questionData.score) + "分) ", 1))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_6, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.updateImgH5List, (option, index) => {
        return (_openBlock(), _createElementBlock("div", {
          class: _normalizeClass([[index !== 0 ? 'dv-option-mt47' : 'dv-option-mt2'], "dv-option-answer"]),
          key: option.option_id,
          onClick: ($event: any) => (_ctx.handleAnswer(option.option_id))
        }, [
          _createElementVNode("div", {
            class: "dv-option",
            style: _normalizeStyle({
            borderColor:
              _ctx.currentAnswer === option.option_id ? '#1ac36e' : '#e3e3e3',
          })
          }, [
            _createElementVNode("div", _hoisted_8, _toDisplayString(String.fromCharCode(65 + index)), 1),
            _createElementVNode("div", {
              class: "dv-options-topic",
              innerHTML: option.content
            }, null, 8, _hoisted_9)
          ], 4),
          (_ctx.props.disabled && option.option_id === _ctx.correctOption)
            ? (_openBlock(), _createElementBlock("div", _hoisted_10, _hoisted_12))
            : _createCommentVNode("", true),
          (
            _ctx.props.disabled &&
            _ctx.currentAnswer !== _ctx.correctOption &&
            option.option_id === _ctx.currentAnswer
          )
            ? (_openBlock(), _createElementBlock("div", _hoisted_13, _hoisted_15))
            : _createCommentVNode("", true)
        ], 10, _hoisted_7))
      }), 128))
    ]),
    (_ctx.props.disabled)
      ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
          _hoisted_17,
          _createElementVNode("div", {
            class: "analysis-content",
            innerHTML: _ctx.props?.question?.analysis || ''
          }, null, 8, _hoisted_18)
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_ElDialog, {
      width: 790,
      top: "8%",
      modelValue: _ctx.clickImgState,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.clickImgState) = $event)),
      onClose: _ctx.clickImg,
      "append-to-body": true
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_19, [
          _createElementVNode("img", {
            class: "w100",
            src: _ctx.clickImgUrl
          }, null, 8, _hoisted_20)
        ])
      ]),
      _: 1
    }, 8, ["modelValue", "onClose"])
  ]))
}